module.exports = __webpack_public_path__ + "img/a555@2x.0821c001.png";